var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61266 0.946641C8.09266 0.426641 7.25266 0.426641 6.73266 0.946641L0.612656 7.06664C0.0926563 7.58664 0.0926563 8.42664 0.612656 8.94664L6.73266 15.0666C7.25266 15.5866 8.09266 15.5866 8.61266 15.0666C9.13266 14.5466 9.13266 13.7066 8.61266 13.1866L3.43932 7.99997L8.61266 2.82664C9.13266 2.30664 9.11932 1.45331 8.61266 0.946641Z",
    fill: "#282860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.35e8bbae1c34d2da530dda107ab1314a.svg";
export { ForwardRef as ReactComponent };